import app from "./app";
import gpt from "./gpt";
import gallary from "./gallary";

export { default as app } from "./app";
export { default as gpt } from "./gpt";
export { default as gallary } from "./gallary";

export function resetAllModulesState() {
  app.resetState();
  gpt.resetState();
  gallary.resetState();
}
